










import { Component, Vue, Watch } from 'vue-property-decorator';
import constant from './mixins/const';

import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue';
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);


import VModal from 'vue-js-modal';
Vue.use(VModal, {
    dialog: true,
    dynamic: true
});

import {currencyData, pageInfo} from '@/mixins/interface';
import format from "@/mixins/format";
import _ from 'lodash';


@Component({})
export default class App extends Vue {
    public isPWA = false;
    public pageInfo: pageInfo = {
        displayHeader: false,
        headerTitle: '',
        headerTitleLong: false,
        prevPage: null,
        prevParams: [],
        developStatus: 0
    };
    private maintenanceOverTime = '0000/00/00 00:00';
    private readBalanceLimitPerPage: number = 0;
    private tokenInitializeFlg: boolean = false;

    @Watch ('$route', {immediate: true})
    watchRoute() {
        this.readBalanceLimitPerPage = 0;
        console.error('this.$route(watchRoute)->', 'name:' + this.$route.name + '/path:' + this.$route.path);
        // 画面の状態を取得
        const displayStatus = this.getDisplayStatus();
        const thisVar = this;
        // 画面の状態から動作を決定
        this.checkDisplayStatus(displayStatus)
        .then(function(redirect: any) {
            if (redirect == '') {
                // リダイレクト不要
                console.log('auth success!', redirect);
                thisVar.pageControl();
            } else {
                // 制御が必要
                console.error('決定したリダイレクト先は→" ' + redirect + ' "');
                thisVar.$router.replace({name: redirect});
            }
        })
        .catch(function(redirect: any) {
            console.error('checkDisplayStatus catch redirect to', redirect);
            thisVar.$router.replace({name: 'start'});
        });
    }

    /**
     * 画面の状態を取得
     */
    getDisplayStatus() {
        console.log('this.$route(getDisplayStatus):', this.$route);
        console.log('is this standalone?', window.matchMedia('(display-mode: standalone)').matches);
        let status = '';
        const testingEnv = 'PWA'; // PWA or web
        // PWA判定
        if(
            window.matchMedia('(display-mode: standalone)').matches
            // || (location.hostname === 'vm.ofstest.com' && testingEnv == 'PWA')
        ) {
            this.isPWA = true;
            if (this.$route.path == '/' && this.$route.name == null) {
                status = 'isEnvPWA/isFirst';
            } else if (this.isUnderPwaPage()) {
                // 現環境がPWA環境下の場合、かつ現在地がPWA統治下のページの場合
                status = 'isEnvPWA/isUnderPWA';
            } else {
                // 現環境がPWA環境下の場合、かつ現在地がPWA統治外のページの場合
                status = 'isEnvPWA/isNotUnderPWA';
            }
        } else {
            this.isPWA = false;
            if (this.$route.path == '/' && this.$route.name == null) {
                status = 'isNotEnvPWA/isFirst';
            } else if (this.isUnderPwaPage()) {
                // 現環境がPWA環境下ではない場合、かつ現在地がPWA統治下のページの場合
                status = 'isNotEnvPWA/isUnderPWA';
            } else {
                // 現環境がPWA環境下ではない場合、かつ現在地がPWA統治外のページの場合
                status = 'isNotEnvPWA/isNotUnderPWA';
            }
        }
        console.log('getDisplayStatus', status);
        return status;
    }

    /**
     * 画面の状態を引数に、
     * 強制リダイレクトが必要か否かを判定する
     */
    async checkDisplayStatus(status: string) {
        try {
            console.log('check start! status:' + status, this.$route);
            let redirect = '';
            if (status === 'isEnvPWA/isFirst') {
                console.error('PWA環境で SSR直後のページだからいったんtokenページに回す', this.$route.name);
                if (this.$store.getters.getVwIdb == null) {
                    await this.$store.dispatch('initDB');
                }
                redirect = 'token';
            } else if (status === 'isEnvPWA/isUnderPWA') {
                console.error('PWA環境で PWA専用ページにあアクセスしてるのでウォレットの存在チェックを行います', this.$route.name);
                if (this.$store.getters.getVwIdb == null) {
                    await this.$store.dispatch('initDB');
                }
                const exists = await this.$store.dispatch('accountModule/accountExists');
                if (!exists) {
                    // 普通にPWAでPWA統治ページを開いてるだけだが、ウォレットを作成していない
                    if (!this.isStartingPage()) {
                        redirect = 'start';
                        console.error('accountはないけどスタートページ以外にアクセスしようとしちゃってるのでstartに飛ばします');
                    } else {
                        console.log('アカウントを確認できませんがスタートページにいます')
                    }
                } else {
                    // 普通にPWAでPWA統治ページを開いてるだけ
                    if (this.isStartingPage()) {
                        redirect = 'token';
                        console.error('accountはあるのにスタートページにいるので、tokenに飛ばします');
                    } else {
                        console.log('普通にPWAでPWA統治ページを開いてますしアカウントもあります。そのままどうぞ')
                        // 残高とかの取得スクリプトマスターの起動
                        this.tokenInitializeFlg = true;
                    }
                }
            } else if (status === 'isEnvPWA/isNotUnderPWA') {
                // PWA環境で開いてるのにPWA統治外webページを開けばtokenへ遷移
                console.error('PWAなのにwebページ開いてます');
                redirect = 'token';
            } else if (status === 'isNotEnvPWA/isUnderPWA') {
                // PWA環境じゃないけどPWA統治ページにいたらindexへ遷移
                console.error('webなのにPWA開いてます');
                redirect = 'index';
            } else {
                // isNotEnvPWA/isNotUnderPWA & isNotEnvPWA/isFirst
                // 普通にwebページを開いてるだけ
                redirect = '';
            }
            return redirect
        } catch(e) {
            console.error(e);
            throw new Error('system error');
        }

    }

    /**
     * ページの情報からページのタイトルと戻り先ページを取得する
     */
    pageControl() {
        let thisVar = this;
        console.log('this.$route(pageControl)', this.$route);
        if (this.$route.name == 'start') {
            console.log('start page control', this.$route);
            // ヘッダなし
            this.pageInfo.displayHeader = false;
            this.pageInfo.headerTitle = '';
            this.pageInfo.prevPage = null;
            this.pageInfo.prevParams = [];
            this.pageInfo.headerTitleLong = false;
            this.pageInfo.developStatus = 0;
        } else if (this.isUnderPwaPage()) {
            // 現在地がPWA条件下のページ
            console.log('isUnderPWA page control', this.$route);
            // ページ情報を取得
            this.$store.dispatch('getPageInfo', this.$route.name)
            .then(function(pageInfoData: any) {
                console.log('pageInfo', pageInfoData);
                // タイトルが18文字以上か
                let headerTitleLong = false;

                // タイトル部分制御
                if (pageInfoData.title.length > 18) {
                    headerTitleLong = true;
                }
                if (pageInfoData.title == '') {
                    pageInfoData.title = 'logo';
                }
                if (pageInfoData.prevPage != undefined) {
                    pageInfoData.prevParams = pageInfoData.prevParams;
                } else {
                    pageInfoData.prevParams = [];
                }

                thisVar.pageInfo = {
                    displayHeader: true,
                    headerTitle: pageInfoData.title,
                    prevPage: pageInfoData.prevPage,
                    prevParams: pageInfoData.prevParams,
                    headerTitleLong: headerTitleLong,
                    developStatus: pageInfoData.developStatus
                };
                console.log(thisVar.pageInfo);
            })
            .catch(function() {
                // thisVar.$modal.show('dialog', {title: 'エラー', text: 'アプリケーションページの情報を取得できません。/name:' + thisVar.$route.name + '/path:' + thisVar.$route.path });
                console.error('アプリケーションページの情報を取得できません。-> name: "' + thisVar.$route.name + '", path: "' + thisVar.$route.path + '"');
            });
        } else {
            console.log('isNotUnderPWA page control', this.$route);
            // PWA統治ではない場合ssrでのページ遷移は$route.nameが取れないため記述を分離
            this.pageInfo.displayHeader = true;
            this.pageInfo.headerTitle = 'logo';
            this.pageInfo.prevPage = '';
            this.pageInfo.headerTitleLong = false;
            this.pageInfo.developStatus = 0;
        }
    }

    /**
     * 現在のページがPWA条件下のみのページか通常のwebページなのか判定する
     * true:PWA条件下のみのページ/false:通常のwebページ
     */
    isUnderPwaPage() {
        if (
            this.$route.name !== 'index'
            && this.$route.name !== 'howto'
            && this.$route.name !== 'rules'
            && this.$route.name !== 'about'
            && this.$route.name !== 'faq'
        ) {
            // 現在地がPWA条件下のみのページ
            console.log('is is pwa!!!!!!!!!!!!', this.$route.name)
            return true;
        } else {
            // 現在地がPWA条件下以外のページ
            // webページ
            console.log('is is not pwa!!!!!!!!!!!!', this.$route.name)
            return false;
        }
    }

    /**
     * 現在のページがwallet作成/復元ページか否かを判定する
     * true:PWA条件下のみのページ/false:通常のwebページ
     */
    isStartingPage() {
        const name: string | undefined | null = this.$route.name;
        let result;
        if (name != undefined && name.indexOf('start') === 0) {
            // wallet作成/復元ページ(startingPage)
            result =  true;
        } else {
            // wallet作成/復元ページではない
            result =  false;
        }
        return result;
    }

    created() {
        if(window.matchMedia('(display-mode: standalone)').matches){
            this.isPWA = true;
            // iOSのポップアップが残る場合があるのでここで強制削除
            const idxOverlay = document.getElementById('index-overlay');
            if (idxOverlay != null) {
                idxOverlay.style.display = 'none';
            }
        }

        this.$store.dispatch('setRouter', this.$route)
        .then(async () => {
            // service workerの確認
            console.log('sw', navigator);
            if ('serviceWorker' in navigator) {
                const registration = await navigator.serviceWorker.register('/service-worker.js')
                console.log("serviceWorker registered.", registration);

                registration.onupdatefound = function () {
                    console.log('アップデートがあります！');
                    registration.update();
                }
            }
            console.log('apiHost', constant.apiHost);
        })
        .catch((e: any) => {
            console.error(e);
        })
    }

    @Watch('tokenInitializeFlg')
    tokenInitialize() {
        console.log('token init');
        let currencyList: any[] = [];
        // リストを取得
        this.getCurrencyList()
        .then(async (response: any[]) => {
            // 取得できてたらTOPページを初期化
            console.log('tokenIndex', this.$store.getters.getTokenIndexInitSwitch);
            await this.$store.dispatch('setTokenIndexInitSwitch', true);
            console.log('tokenIndex', this.$store.getters.getTokenIndexInitSwitch);

            currencyList = _.cloneDeep(response);
            // 残高取得 履歴取得 非同期実行
            this.execute(currencyList);
            // 残高取得は5分に一度(ページ遷移しなかったら4回まで)->1回+(5分*3回)=15分間だけ有効
            const balanceInterval = 1000 * 60 * 5;
            // 残高を取得して反映
            setInterval( () => {
                if (this.readBalanceLimitPerPage < 3) {
                    console.log('BACK:自動実行', (this.readBalanceLimitPerPage+1)+'回目');
                    this.readBalanceLimitPerPage++;
                    // 残高取得 履歴取得 非同期実行
                    this.execute(currencyList);
                } else {
                    console.warn('BACK:自動実行開始できません', (this.readBalanceLimitPerPage+1)+'回目');
                }
            }, balanceInterval);
            return;
        });
    }

    /**
     * indexedDBから通貨リストを取得してVuexに置く
     * そしてアカウントの有無を返す
     */
    async getCurrencyList() {
        const currencyDataList: currencyData[] = await this.$store.dispatch('accountModule/getAllCurrencyAccounts');
        console.log('all', currencyDataList);
        if (currencyDataList.length === 0) {
            return [];
        } else {
            return currencyDataList;
        }
    }

    /**
     * 残高を取得してindexedDBに保管してVuexにも反映
     * トランザクション履歴を取得してindexedDBに保管
     * Bitcoinの受け取りアドレス更新
     */
    execute(currencyList: any) {
        console.log('BACK:バックエンドプログラム開始します', currencyList);
        if (currencyList != undefined) {
            for (let i = 0; i < currencyList.length; i++) {
                console.log('BACK:更新開始', currencyList[i].name)
                // 残高を取得してindexedDBに保管
                this.updateCurrencyAmount(currencyList[i]);

                // トランザクション履歴を取得してindexedDBに保管
                this.$store.dispatch('walletModule/getActiveHistories', currencyList[i].name);

                // bitcoinの場合アドレスの消費チェックを行う
                if (currencyList[i].platform == 'Bitcoin') {
                    // アドレス更新
                    console.log('this is bitcoin')
                    this.usedAddressCheck(currencyList[i]);
                }
            }
        }
    }

    /**
     * 残高を取得してindexedDBに保管してVuexにも反映
     */
    async updateCurrencyAmount(currencyData: currencyData) {
        const name = currencyData.name;
        // 残高取得
        console.log('BACK:残高取得開始', name);
        const realtimeData = await this.$store.dispatch('walletModule/getCurrencyAmount', currencyData)
        console.log('BACK:残高取得完了', realtimeData);

        if (realtimeData.status == 'error' && realtimeData.data.amount == 0) {
            console.warn('BACK:error', name, realtimeData);
            // サーバーが弱かったりでエラーになった場合
            setTimeout(() => {
                // 60秒後に再帰的に再実行
                this.updateCurrencyAmount(currencyData);
            }, 60000);
        } else {
            // Vuexに通貨の情報が追加されているか検索
            const displayedList = this.$store.getters.getCurrencyList;
            console.log('BACK:VuexState内のリストを取得:', displayedList);

            const displayedData = displayedList.filter((account: any) => {
                return account.name == name
            });
            console.log('BACK:残高更新 比較', name, displayedData.amount, '->', realtimeData.data.amount);

            // 残高の更新が必要な場合
            if (displayedData && displayedData.amount != realtimeData.data.amount) {
                // Vuexに項目が追加されてたら
                // indexedDBの内容をVuexに反映
                console.log('BACK:Vuex検索結果', name);
                await this.$store.dispatch('setCurrencyListProps', {name: name, key: 'amount'});
                await this.$store.dispatch('setCurrencyListProps', {name: name, key: 'initialized'});
            }
        }
        return true;
    }

    async usedAddressCheck(currencyData: currencyData) {
        let unused = await this.$store.dispatch('accountModule/checkUnspentAddr', {
            address: currencyData.address,
            platform: currencyData.platform
        });
        console.log('btc account unused', unused);
        // アドレスの切り替え
        if (!unused) {
            // 現在指定中のアドレスが使用済の場合

            // 新しいpath
            const newPrivIdx = currencyData.privIdx + 1;
            console.log('newPrivIdx', newPrivIdx);
            let searchParam = [
                currencyData.accountNumber,
                newPrivIdx,
                0
            ]
            let addressData;
            try {
                // 次のアドレスを取得
                // このインデックスとアカウントナンバーでbtcAddressテーブルから値を引き出す
                addressData = await this.$store.dispatch('idbSelect', {
                    stateName: null,
                    storeName: 'btcAddress',
                    keyValue: searchParam
                });
            } catch (e) {
                addressData = null;
            }

            console.log('addressData1', addressData);

            if (addressData == null) {
                // アドレスが足りない！！
                console.log('new address add!')
                /**
                 * TODO: ダイアログで新しいアドレスを作成するか固定にするか選択
                 * 新しいアドレス -> pin入力画面に飛ばして新しいアドレス
                 * 固定 -> prividx:0のアカウントに固定
                 * いったん最初のインデックスに戻る
                 */
                searchParam = [
                    currencyData.accountNumber,
                    0,
                    0
                ];
                // 最初のアカウントを取得
                addressData = await this.$store.dispatch('idbSelect', {
                    stateName: null,
                    storeName: 'btcAddress',
                    keyValue: searchParam
                });
            }

            // replace address
            currencyData.address = addressData.address;
            currencyData.privIdx = addressData.privIdx;
            console.log('replace address',currencyData, addressData)

            await this.$store.dispatch('accountModule/updateCurrencyAccountProperty', {
                account:currencyData,
                property:['address', 'privIdx']
            });
        }
        return;
    }

    mounted() {
        // スプラッシュ画像の制御
        const splash = document.getElementById('splash');
        if (splash !== null && splash.style.display !== "none") {
            // 1秒待って
            setTimeout(function() {
                splash.classList.add('fadeout');
                // 1秒かけてフェードアウト
                setTimeout(function() {
                    splash.style.display = "none";
                }, 1000);
            }, 1000);
        }
    }
}
